import React from 'react';
import './Signup.scss';
import { Link } from 'react-router-dom';

const Signup = () => {
  return (
    <div className='signup'>
            <div className='signup-container'>
                <div className='signup-form'>
                    <div className='signup-form-content'>
                        <div className='signup-form-head'>
                            <h2> Wrights Nudges</h2>
                        </div>
                        <div className='signup-form-forms'>
                            <div className='signup-form1'>
                                <label> First Name </label>
                                <input type="text" />
                           
                            </div>
                            <div className='signup-form1'>
                                <label> Last Name </label>
                                <input type="text" />
                           
                            </div>
                            <div className='signup-form1'>
                                <label> Email </label>
                                <input type="text" />
                           
                            </div>
                            <div className='signup-form1'>
                                <label> Phone </label>
                                <input type="text" />
                           
                            </div>
                            <div className='signup-form1'>
                                <label> Password </label>
                                <input type="text" />
                           
                            </div>
                            <div className='signup-form1'>
                                <label> Confirm Password</label>
                                <input type="password"  />
                            </div>
                            <div className='signup-form1'>
                                <label> Select your community </label>
                                <input type="password"  />
                            </div>
                            
                        </div>
                        <div className='signup-form-btns'>
                            <button className='btn'>Log in</button>
                            <p className='link'>Already have an account?  <Link to={'/'}>Sign in </Link> </p>
                        </div>
                    </div>
                </div>
                <div className='signup-img'>
                    <div className='signup-img-box'>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Signup